import React, { useState, useEffect } from 'react'

export default function AudioControls({ audioController, audioCollection }) {
  const [playingAudio, setPlayingAudio] = useState([])
  const [controlsAvailable, setControlsAvailable] = useState(true);
  const [playing, setPlaying] = useState(true);
  const [muting, setMuting] = useState(false)

  function handlePlayPause() {
    const playingAudio = document.getElementsByTagName('audio')
    console.log('toggleAudioPlay', playingAudio)
    for (let audio of playingAudio) { 
      if (audio.paused) {
        audio.play()
        setPlaying(true)
      } else {
        audio.pause()
        setPlaying(false)
      }
    }
  }

  function handleRestart() {
    let playing = audioCollection.filter(clip => clip.isPlaying)
    if (playing.length === 1) {
      audioController.audioRestarted(playing[0].name)
    }
    const playingAudio = document.getElementsByTagName('audio')
    // console.log('seek 0', playingAudio)
    // // for (let audio of playingAudio) { audio.fastSeek(0) }
    for (let audio of playingAudio) { audio.load(); }
    // setPlaying(true)
  }

  function handleMute() {
    const playingAudio = document.getElementsByTagName('audio')
    console.info('muting', playingAudio)
    // TODO: Explicitly define mute and unmute cases
    for (let audio of playingAudio) { audio.muted = !audio.muted }
    setMuting(!muting)
  }

  useEffect(() => {
    let playing = audioCollection.filter(clip => clip.isPlaying)
    console.log(audioCollection, playing, playing.length)
    if (playing.length <= 0) {
      setControlsAvailable(false)
    } else {
      setControlsAvailable(true)
      let isPlaying = (playing[0].ended??false) ? false : playing[0].autoplay??true
      setPlaying(isPlaying)
    }
  }, [audioCollection])

  return (
    <div className={`AudioControls ${controlsAvailable ? 'available' : 'unavailable'}`}>
      <div className={`bookend left`} />
      <div className={`control-panel`}>
        <span className={`text-label`}>Audio</span>
        <div className={`control-wrapper`}>
          <button className={`audio-button playPause-button`} onClick={handlePlayPause}>
            <i className={`icon playPause-icon ${playing ? 'playing' : 'paused'}`} />
          </button>
          <button className={`audio-button restart-button`} onClick={handleRestart}>
            <i className={`icon restart-icon`} />
          </button>
          <button className={`audio-button mute-button`} onClick={handleMute}>
            <i className={`icon mute-icon ${muting ? 'mute-on' : 'mute-off'}`} />
          </button>
        </div>
      </div>
      <div className={`bookend right`} />
    </div>
  )
}
